// Environment-scoped auth cookie names.
//
// Dev deployments live on flat subdomains of privacybee.com
// (dev-api…, checkout-dev…), so cookies written at Domain=.privacybee.com are
// stored ONCE per name at the registrable domain and collide across environments:
// logging into dev overwrites the production token (and vice versa), which then
// feeds the wrong environment's refresh token back to the API → 401 refresh loops.
//
// We keep Domain=.privacybee.com but suffix the cookie NAMES per environment. The
// suffix comes from NUXT_PUBLIC_PB_AUTH_COOKIE_SUFFIX (runtimeConfig.public.pb
// .authCookieSuffix): `.dev` on develop, empty everywhere else. An empty suffix
// reproduces today's production names byte-for-byte, and local dev on
// .privacybee.test never collides (different registrable domain), so it also
// stays unsuffixed. The suffix string must match the other repos exactly.

export const BASE_TOKEN_COOKIE = 'auth._token.pb';
export const BASE_REFRESH_COOKIE = 'auth._refresh_token.pb';

export interface AuthCookieNames {
    tokenCookieName: string;
    refreshCookieName: string;
}

/** Compute the token/refresh cookie names for a given environment suffix. */
export function authCookieNames(suffix?: string | null): AuthCookieNames {
    const s = suffix || '';
    return {
        tokenCookieName: `${BASE_TOKEN_COOKIE}${s}`,
        refreshCookieName: `${BASE_REFRESH_COOKIE}${s}`,
    };
}
